import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearchinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 64 64",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 26,
			cy: 26,
			r: 21
		}), /* @__PURE__ */ _jsx("path", { d: "M41 41l17.678 17.678" })]
	})
});
export default SvgSearchinline;
